import styled from "styled-components/macro"

export const StarPosition = styled.div`
  position: absolute;
  left: 100%;
  top: 60%;
`
